<template>
  <div id="shop-edition-product-dialog">
    <v-dialog max-width="500px" scrollable v-model="dialogItem">
      <template v-slot:activator="{ on }">
        <v-btn @click="addItem()" color="primary" dark v-on="on">Create</v-btn>
      </template>
      <v-card>
        <!-- <v-card-title>
          <h1 class="title head-page">Counsulting Topic</h1>
        </v-card-title>-->
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-xl>
            <v-layout justify-center row wrap>
              <v-flex xs6>
                <v-layout align-center justify-center row wrap>
                  <v-subheader class="font-weight-bold">Shop Edition</v-subheader>
                  <v-divider></v-divider>
                  <v-flex xs12>
                    <v-autocomplete
                      clearable
                      :items="shopEditions"
                      item-text="name"
                      item-value="idx"
                      label="Shop"
                      v-model="formData.shopEditionId"
                    ></v-autocomplete>
                    <v-autocomplete
                      clearable
                      :items="shopEditionProducts"
                      item-text="productId"
                      item-value="idx"
                      label="Product"
                      v-model="formData.shopEditionProductId"
                    >
                      <template v-slot:selection="{ item, selected }">
                        <span>{{ mapProductName(item.productId) }}</span>
                      </template>
                      <template v-slot:item="{ item }">
                        <span>{{ mapProductName(item.productId) }}</span>
                      </template>
                    </v-autocomplete>
                    <v-autocomplete
                      clearable
                      :items="shopEditionProductItems"
                      item-text="name"
                      item-value="idx"
                      label="Item"
                      v-model="formData.shopEditionProductItemId"
                    ></v-autocomplete>
                    <v-autocomplete
                      clearable
                      :items="shopEditionProductItemPrices"
                      item-text="name"
                      item-value="idx"
                      label="Price"
                      v-model="formData.shopEditionProductItemPriceId"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout align-center justify-center row wrap>
                  <v-subheader class="font-weight-bold">Details</v-subheader>
                  <v-divider></v-divider>
                  <v-flex xs12>
                    <v-text-field
                      clearable
                      label="Firstname"
                      v-model="formData.firstname"
                    ></v-text-field>
                    <v-text-field
                      clearable
                      label="Lastname"
                      v-model="formData.lastname"
                    ></v-text-field>
                    <v-text-field
                      clearable
                      label="Phone"
                      mask="###-###-####"
                      v-model="formData.phone"
                    ></v-text-field>
                    <v-text-field
                      clearable
                      label="Address"
                      v-model="formData.address"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout align-center justify-center row wrap>
                  <v-subheader class="font-weight-bold">Location</v-subheader>
                  <v-divider></v-divider>
                  <v-flex xs12>
                    <v-autocomplete
                      clearable
                      @input="checkProvince"
                      :items="provinces"
                      item-text="nametha"
                      item-value="id"
                      label="Province"
                      v-model="formData.province"
                    ></v-autocomplete>
                    <!-- district -->
                    <v-autocomplete
                      clearable
                      :disabled="formData.province ? false : true"
                      @input="checkDistrict"
                      :items="districts"
                      item-text="nametha"
                      item-value="id"
                      label="District"
                      v-model="formData.district"
                    ></v-autocomplete>
                    <!-- sub district -->
                    <v-autocomplete
                      clearable
                      :disabled="formData.district ? false : true"
                      :items="subDistricts"
                      item-text="nametha"
                      item-value="id"
                      label="SubDistrict"
                      v-model="formData.subDistrict"
                    ></v-autocomplete>
                    <!-- zipcode -->
                    <v-text-field
                      clearable
                      label="Zipcode"
                      type="number"
                      v-model.number="formData.zipcode"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout align-center justify-center row wrap>
                  <v-subheader class="font-weight-bold">Other</v-subheader>
                  <v-divider></v-divider>
                  <v-flex xs12>
                    <v-text-field
                      clearable
                      label="Quantity"
                      type="number"
                      v-model.number="formData.quantity"
                    ></v-text-field>
                    <v-text-field
                      clearable
                      hide-details
                      label="Total Price"
                      type="number"
                      v-model.number="formData.totalPrice"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select :items="status" label="Status" v-model="formData.status"></v-select>
                    <v-textarea clearable label="Note" v-model="formData.note"></v-textarea>
                  </v-flex>
                </v-layout>
                <v-layout align-center justify-center row wrap>
                  <v-subheader class="font-weight-bold">Slip</v-subheader>
                  <v-divider></v-divider>
                  <v-flex v-if="formData.transferSlip" xs12>
                    <a class="caption" :href="formData.transferSlip" target="blank"
                      >Transfer Slip</a
                    >
                  </v-flex>
                  <v-flex v-else xs12>
                    <input
                      accept="image/*"
                      @change="detectFiles($event)"
                      id="files"
                      :multiple="false"
                      name="file"
                      ref="uploadInput"
                      type="file"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            @click="doDelete(formData.idx, formData.transferSlip)"
            color="red"
            dark
            v-if="formData.idx"
            >Delete</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn @click.stop="dialogItem = !dialogItem" color dark>Close</v-btn>
          <v-btn @click="doSubmit()" color="green" dark :loading="dialogLoading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from 'firebase/app' // Storage
import 'firebase/storage'

export default {
  name: 'shop-edition-product-dialog',
  data() {
    return {
      formData: [],
      dialogLoading: false,
      status: [
        'รอตรวจสอบ',
        'ตรวจสอบแล้ว',
        'กำลังบรรจุ',
        'อยู่ระหว่างขนส่ง',
        'เสร็จสิ้น',
        'ยกเลิกโดยลูกค้า',
        'ยกเลิกโดยระบบ'
      ],
      fileSlip: null
    }
  },
  watch: {
    dialogItem() {
      if (this.$store.state.ShopOrderList.idx) {
        this.formData = this.$store.getters['ShopOrderList/getAll'].filter(
          item => item.idx == this.$store.state.ShopOrderList.idx
        )[0]
      } else {
        this.formData = []
      }
    }
  },
  computed: {
    provinces() {
      return this.$store.getters['Place/getProvinceAll']
    },
    districts() {
      return this.$store.getters['Place/getDistrictAll'].filter(
        item => item.provinceid == this.formData.province
      )
    },
    subDistricts() {
      return this.$store.getters['Place/getSubDistrictAll'].filter(
        item => item.districtid == this.formData.district
      )
    },
    shopEditions() {
      return this.$store.state.ShopEdition.data
    },
    shopEditionProducts() {
      return this.$store.state.ShopEditionProduct.data.filter(
        item => item.shopEditionId == this.formData.shopEditionId
      )
    },
    shopEditionProductItems() {
      return this.$store.state.ShopEditionProductItem.data.filter(
        item => item.shopEditionProductId == this.formData.shopEditionProductId
      )
    },
    shopEditionProductItemPrices() {
      return this.$store.state.ShopEditionProductItemPrice.data.filter(
        item => item.shopEditionProductItemId == this.formData.shopEditionProductItemId
      )
    },
    products() {
      return this.$store.state.Product.searchProducts
    },
    dialogItem: {
      // getter
      get() {
        return this.$store.state.ShopOrderList.dialog
      },
      // setter
      set(newValue) {
        this.$store.commit('ShopOrderList/UPDATE_DIALOG', newValue)
      }
    }
  },
  methods: {
    mapProductName(productId) {
      return this.products
        .filter(item => item.productid == productId)
        .map(item => item.productname)[0]
    },
    checkRegion(region) {
      if (!region) {
        this.formData.provinceId = null
        this.formData.districtId = null
        this.formData.subDistrictId = null
      }
    },
    checkProvince(province) {
      if (!province) {
        this.formData.districtId = null
        this.formData.subDistrictId = null
      }
    },
    checkDistrict(district) {
      if (!district) {
        this.formData.subDistrictId = null
      }
    },
    async doSubmit() {
      try {
        const validate = await this.$validator.validateAll()
        if (validate) {
          this.dialogLoading = !this.dialogLoading
          const data = {
            idx: this.formData.idx,
            shopEditionProductItemPriceId: this.formData.shopEditionProductItemPriceId,
            quantity: this.formData.quantity,
            totalPrice: this.formData.totalPrice,
            firstname: this.formData.firstname,
            lastname: this.formData.lastname,
            phone: this.formData.phone,
            address: this.formData.address,
            province: this.formData.province,
            district: this.formData.district,
            subDistrict: this.formData.subDistrict,
            zipcode: this.formData.zipcode,
            status: this.formData.status,
            note: this.formData.note
          }
          const idx = await this.$store.dispatch(`ShopOrderList/insert`, data)
          if (this.fileSlip) {
            this.upload(idx, this.fileSlip) // upload slip
          }
          this.$store.commit(`ShopOrderList/UPDATE_DIALOG`, false)
          this.formData = []
          this.dialogLoading = !this.dialogLoading
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    doDelete(idx, transferSlip) {
      const answer = window.confirm(`Do you want to Delete ${idx} ?`)
      if (answer) {
        if (transferSlip) {
          // Create a reference to the file to delete
          var desertRef = firebase.storage().refFromURL(transferSlip)
          // Delete the file
          desertRef.delete()
        }
        // Delete in DB
        this.$store.dispatch(`ShopOrderList/delete`, idx)
        this.$store.commit(`ShopOrderList/UPDATE_DIALOG`, false)
      }
    },
    addItem() {
      this.$store.commit('ShopOrderList/UPDATE_DIALOG', true)
      this.$store.commit('ShopOrderList/SET_IDX', null)
    },
    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files
      Array.from(Array(fileList.length).keys()).map(x => {
        this.fileSlip = fileList[x]
      })
    },
    async upload(idx, file) {
      try {
        // Upload images to firebase and get URL
        var storageRef = firebase.storage().ref()

        var ext = file.name.slice(file.name.lastIndexOf('.'))

        // Create the file metadata
        var metadata = {
          contentType: 'image/jpeg'
        }

        // Create Timestamp
        // let timestamp = Date.now()

        this.loading = true

        // Upload file and metadata to the object 'images/mountains.jpg'
        var uploadTaskSnapshot = await storageRef
          .child(`transfer_slip/${window.btoa(idx)}${ext}`)
          .put(file, metadata)

        const downloadURL = await uploadTaskSnapshot.ref.getDownloadURL()
        const data = {
          downloadURL: downloadURL,
          idx: idx
          // createdBy: localStorage.getItem('tokenAdmin')
        }
        this.$store.dispatch('ShopOrderList/updateSlip', data)
        // reset file input
        const input = this.$refs.uploadInput
        input.type = 'text'
        input.type = 'file'
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
